const imports = import.meta.glob('../../app/**/translations.json', { eager: true })

let locale = "nl" // TODO: make dynamic

export function translate(string, vars = null, localeOverride = null) {
    const lang = localeOverride || locale
    const translation = translations[lang]?.[string]

    // fallback if no translation found
    if (!translation) return string

    // if no vars, return translation as-is
    if (!vars) return translation

    // if vars is an object, replace {key} placeholders
    if (typeof vars === 'object' && !Array.isArray(vars)) {
        return translation.replace(/\{(\w+)\}/g, (_, key) =>
            key in vars ? vars[key] : `{${key}}`
        )
    }

    // if vars is an array, replace %% placeholders in order
    if (Array.isArray(vars)) {
        let i = 0
        return translation.replace(/%%/g, () => vars[i++] ?? '')
    }

    // fallback: just return translation
    return translation
}

const translations = {
    "nl": {
        // NL: translations
    },
    "de": {
        // ...
    },
    "en": {
        // ...
    }
}

// Append module translations
for (const mod of Object.values(imports)) {
    for (const locale in mod) {
        if (!translations[locale]) {
            translations[locale] = {}
        }

        Object.assign(translations[locale], mod[locale])
    }
}

// console.log(translations)